(function () {
  var hoverQuery = window.matchMedia('(hover: hover) and (min-width: 990px)');

  function setExpanded(details, open) {
    var summary = details.querySelector('summary');
    if (open) details.setAttribute('open', '');
    else details.removeAttribute('open');
    if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeAll(except) {
    document.querySelectorAll('[data-hover-menu] details').forEach(function (d) {
      if (d !== except) setExpanded(d, false);
    });
  }

  function bindHoverMenu(nav) {
    nav.querySelectorAll('header-menu').forEach(function (item) {
      var details = item.querySelector('details');
      var timer;
      if (!details) return;
      item.addEventListener('mouseenter', function () {
        if (!hoverQuery.matches) return;
        clearTimeout(timer);
        closeAll(details);
        setExpanded(details, true);
      });
      item.addEventListener('mouseleave', function () {
        if (!hoverQuery.matches) return;
        timer = setTimeout(function () {
          setExpanded(details, false);
        }, 120);
      });
      item.addEventListener('focusin', function () {
        clearTimeout(timer);
        closeAll(details);
        setExpanded(details, true);
      });
      item.addEventListener('focusout', function (event) {
        if (item.contains(event.relatedTarget)) return;
        setExpanded(details, false);
      });
      item.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' || !details.hasAttribute('open')) return;
        event.stopPropagation();
        closeAll();
        var trigger = details.querySelector('summary');
        if (trigger) trigger.focus();
      });
    });
  }

  function bindStickyBar() {
    var bar = document.querySelector('.jb-sticky-bar');
    if (!bar) return;
    document.body.classList.add('has-jb-sticky-bar');
    bar.addEventListener('click', function (event) {
      var link = event.target.closest('[data-sticky-action]');
      if (!link) return;
      var action = link.getAttribute('data-sticky-action');
      if (action === 'menu') {
        event.preventDefault();
        var summary = document.querySelector('header-drawer summary');
        if (summary) summary.click();
      } else if (action === 'search') {
        var searchSummary = document.querySelector('details-modal.header__search summary');
        if (searchSummary) {
          event.preventDefault();
          searchSummary.click();
        }
      } else if (action === 'cart') {
        var bubble = document.querySelector('#cart-icon-bubble');
        if (bubble && document.querySelector('cart-drawer')) {
          event.preventDefault();
          bubble.click();
        }
      }
    });
  }

  function updateStickyCount() {
    fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-sticky-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  function bindSearchCategory(form) {
    var select = form.querySelector('[data-jb-search-category]');
    var input = form.querySelector('input[name="q"]');
    if (!select || !input) return;
    form.addEventListener('submit', function (event) {
      var option = select.options[select.selectedIndex];
      if (!option || !option.value) return;
      var term = input.value.trim();
      if (!term && option.dataset.url) {
        event.preventDefault();
        window.location.href = option.dataset.url;
        return;
      }
      input.value = term + ' ' + option.value;
    });
  }

  function bindCompactHeader() {
    var section = document.querySelector('.section-header');
    if (!section) return;
    var ticking = false;
    var threshold = 0;
    function measure() {
      if (section.classList.contains('jb-compact')) return;
      threshold = section.getBoundingClientRect().bottom + window.scrollY;
    }
    function update() {
      ticking = false;
      var y = window.scrollY;
      var compact = section.classList.contains('jb-compact');
      if (!compact && y > threshold + 10) section.classList.add('jb-compact');
      else if (compact && y <= threshold - 10) section.classList.remove('jb-compact');
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', measure);
    var drawerSummary = document.querySelector('header-drawer summary');
    if (drawerSummary) {
      drawerSummary.addEventListener('click', function () {
        var wrapper = section.querySelector('.header-wrapper');
        if (!wrapper || !section.classList.contains('jb-compact')) return;
        document.documentElement.style.setProperty('--header-bottom-position', Math.round(wrapper.getBoundingClientRect().bottom) + 'px');
      });
    }
    measure();
    update();
  }

  function init() {
    bindCompactHeader();
    document.querySelectorAll('[data-jb-search]').forEach(bindSearchCategory);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, updateStickyCount);
    }
    document.querySelectorAll('[data-hover-menu]').forEach(bindHoverMenu);
    bindStickyBar();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
